module.exports = __webpack_public_path__ + "assets/img/icon_sel_client.250f90ab.svg";